import {query} from 'api';
import {getSlugFromUri} from 'lib';
import PropTypes from 'prop-types';
import {Slide, Image, SlideText, SlideTitle, HeadlineMedium, MainTitle, Mask, Button} from 'ui';

const RecipeSlide = ({data, recettes_slider_titre, pageTitle, subTitle, recettes_slider_url}) => {
  if (!data) return null;
  return (
    <Slide>
      <Image src={data.source_url} />
      <Mask />
      <SlideText>
        <SlideTitle>{pageTitle}</SlideTitle>
        <HeadlineMedium>{subTitle}</HeadlineMedium>
        <MainTitle>{recettes_slider_titre}</MainTitle>
        <Button
          to={{
            pathname: `/post/${encodeURIComponent(getSlugFromUri(recettes_slider_url))}`,
            state: {postURI: recettes_slider_url},
          }}
          style={{marginTop: 'auto'}}>
          Voir la recette
        </Button>
      </SlideText>
    </Slide>
  );
};

RecipeSlide.propTypes = {
  data: PropTypes.object,
  recettes_slider_titre: PropTypes.string,
  pageTitle: PropTypes.string,
  subTitle: PropTypes.string,
  recettes_slider_url: PropTypes.string,
};

export default RecipeSlide |> query('getPost', {loadingHidden: true});
